import { EnumUtility } from '@codequality/vue-cli-base';
import mixins from 'vue-typed-mixins';

import { Eフェーズ種別, E入力分類, E科目別計画設定番号 } from '@/openapi/enum';
import { データApi, データListItemRequest, 勘定科目Api, 部門Api } from '@/openapi/user';

import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';
import C保存Button from '@/components/保存Button/保存Button.vue';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import AlertMixin from '@/mixins/AlertMixin';
import TabsMixin from '@/mixins/TabsMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import { TデータPlbscf } from '@/classes/service/AbstractPlbscfService';
import { Tデータ科目別計画Config } from '@/classes/service/Abstract計画PlbscfService';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(AlertMixin, TabsMixin, 計画書Mixin).extend({
  name: 'PlbscfMixin',

  components: {
    MoneyUnitSelect,
    C保存Button,
  },

  data(): {
    api: {
      d: データApi;
      k: 勘定科目Api;
      b: 部門Api;
    };
    tabTypes: PlbscfType[];
    isEditing: boolean;
    isLoading: boolean;
    reloadFlag: boolean;
  } {
    return {
      api: {
        d: UserApiUtility.ogApi(データApi),
        k: UserApiUtility.ogApi(勘定科目Api),
        b: UserApiUtility.ogApi(部門Api),
      },
      tabTypes: [], // ※呼び出し元で上書きする前提
      isEditing: false,
      isLoading: false,
      reloadFlag: true,
    };
  },

  computed: {
    tabs(): string[] {
      return this.tabTypes.map((tabType) => {
        const label = EnumUtility.valueToKey(PlbscfType, tabType);
        return tabType === PlbscfType.損益計算書 ? label + '（製造原価）' : label;
      });
    },
    tabType(): PlbscfType {
      return this.tabTypes[this.tabIndex()];
    },
    is貸借対照表Tab(): boolean {
      return this.tabType === PlbscfType.貸借対照表;
    },
    isCF計算書Tab(): boolean {
      return this.tabType === PlbscfType.CF計算書;
    },
    isFCFTab(): boolean {
      return this.tabType === PlbscfType.FCF;
    },
  },

  methods: {
    async saveデータ(
      tデータPlbscfs: TデータPlbscf[],
      configs?: Tデータ科目別計画Config[],
      eフェーズ種別: Eフェーズ種別 = Eフェーズ種別.分析フェーズ,
      yConfigs?: Tデータ科目別計画Config[]
    ): Promise<void> {
      // 保存対象
      // ・貸借・損益：編集可能箇所
      // ・CF計算書：手で入力した箇所
      // ⇒ item.value が入力されているもの
      const tデータPlbscfsToSave: TデータPlbscf[] = tデータPlbscfs.map((t) => {
        const items = t.items.filter((item) => item.value !== undefined || item.yValue !== undefined);
        return {
          ...t,
          items,
        };
      });
      // リクエスト生成
      const requests: データListItemRequest[] = tデータPlbscfsToSave.map((tデータPlbscf) => ({
        pk: tデータPlbscf.データpk,
        c入力分類:
          eフェーズ種別 === Eフェーズ種別.モニタリングフェーズ ? E入力分類.モニタリングPLBSCF : E入力分類.PLBSCF,
        c番号: tデータPlbscf.番号,
        c部門pK: tデータPlbscf.部門pk,
        cフェーズ種別: eフェーズ種別,
        cデータ: JSON.stringify(tデータPlbscf.items),
      }));
      if (configs !== undefined) {
        configs.forEach((d) => {
          requests.push({
            pk: d.データpk,
            c入力分類: E入力分類.科目別計画設定,
            c番号:
              eフェーズ種別 === Eフェーズ種別.モニタリングフェーズ
                ? E科目別計画設定番号.モニタリングフェーズ
                : E科目別計画設定番号.計画フェーズ,
            c部門pK: d.部門pk,
            cフェーズ種別: eフェーズ種別,
            cデータ: JSON.stringify(d.items),
          });
        });
      }
      if (yConfigs !== undefined) {
        yConfigs.forEach((d) => {
          requests.push({
            pk: d.データpk,
            c入力分類: E入力分類.YEARCONFIG,
            c番号:
              eフェーズ種別 === Eフェーズ種別.モニタリングフェーズ
                ? E科目別計画設定番号.モニタリングフェーズ
                : E科目別計画設定番号.計画フェーズ,
            c部門pK: d.部門pk,
            cフェーズ種別: eフェーズ種別,
            cデータ: JSON.stringify(d.items),
          });
        });
      }
      // API呼び出し
      const response = await this.api.d.bulkSaveデータ(this.計画書.pk, requests);
      if (this.isValidationErrorResponse(response)) return;

      // insert対象（pkがundefined）であるrequestが存在する場合、再読み込みが必要なのでreloadFlagをtrueにする／既にfalseなら何もしない
      if (this.reloadFlag) this.reloadFlag = requests.filter((request) => request.pk === undefined).length > 0;
      // window.alert('保存しました');
    },
    initializeFlag(): void {
      this.isLoading = true;
      this.isEditing = false;
    },
  },
});
